import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '@/components/feedback/EmptyState'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'

/** A money block the server could not serve, said once for both money tabs
 *  (S-11 revision: «Счета клиенту» and «Затраты» read the same block).
 *
 *  Both reasons — `not-configured` and `read-failed` — are the same rendering
 *  for a founder: something went wrong, try again. They are distinguished in
 *  the server's log, which is where the difference is actionable.
 *
 *  EmptyState rather than ErrorState, and the choice is deliberate rather than
 *  lazy: ErrorState derives its words from a problem document, and there is no
 *  problem document here — the case request SUCCEEDED and only this part of it
 *  is missing. Handing ErrorState a non-ApiError makes describeProblem fall
 *  through to its network copy, which would tell the reader they are offline
 *  while the rest of the page renders fine. */
export function MoneyUnavailable({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation()

  return (
    <Card>
      <EmptyState
        icon={TriangleAlert}
        title={t('cases.money.unavailableTitle')}
        description={t('cases.money.unavailableDescription')}
        action={
          onRetry ? (
            <Button variant="secondary" size="sm" onClick={onRetry}>
              {t('common.actions.retry')}
            </Button>
          ) : undefined
        }
      />
    </Card>
  )
}
